/**************************************************
 * Nombre:       Detalle_Coleccion_Titulo_Imgs
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import uno from "../../../Recursos/vista_uno.png";
import dos from "../../../Recursos/vista_dos.png";
import tres from "../../../Recursos/vista_tres.png";
import Tarjeta_Img_Producto from "../../Tarjetas/Tarjeta_Img_Producto";
import {useEffect, useRef, useState} from "react";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";


const Detalle_Coleccion_Titulo_Imgs = ({coleccion}) => {
    const {sCell, sTab} = useResponsive()
    const refe = useRef(null)
    const [fotos, setFotos] = useState([])


    const agruparFotos = (arr) => {

        let fots = []

        arr.forEach(item => {
            if (Array.isArray(item.imgs)) {
                fots.push(...item.imgs);
            }
        });

        setFotos(fots)


    }

    useEffect(() => {

        if (coleccion.id) {
            let w = [where('idColeccion', '==', coleccion.id)]
            obtenerColWheres({col: 'fotos', wheres: w}).then((dox) => {
                if (dox.res) {
                    agruparFotos(dox.data)
                }
            })
        }


    }, [coleccion])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 3 : 6, color: theme.palette.primary.main, mt: sCell ? 4 : 6}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}

                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <Typography sx={{fontSize: sCell ? 14 : 16}}>COLECCIÓN</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <Typography sx={{
                                fontSize: sCell ? 32 : 48,
                                fontFamily: "MD Serif Display",
                                fontWeight: 600,
                                lineHeight: 1.1
                            }}>{coleccion.nombre ? coleccion.nombre : ''}</Typography>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{mt: sCell ? 1 : 0}}>
                    <Typography sx={{textAlign: 'rigth'}}>
                        {coleccion.descripcion ? coleccion.descripcion : ''}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 6}}>

                    {fotos.length > 4 ?

                        <Splide
                            ref={refe}
                            aria-label="My Favorite Images" style={{width: '100%'}}
                            options={{
                                autoplay: true,
                                speed: 1500,
                                rewind: true,
                                perPage: sCell ? 1 : sTab ? 2 : 3,
                                arrows: true,
                                perMove: 1,
                                pagination: true,
                                width: '100%',
                                drag: 'free',
                                snap: true,
                                interval: 5000,
                                noDrag: true,
                                gap: 0,
                                focus: 'center'

                            }}
                        >

                            {fotos.map((item, index) => {
                                return (
                                    <SplideSlide key={`qer${index}`}>
                                        <Tarjeta_Img_Producto item={item}/>
                                    </SplideSlide>
                                )
                            })}


                        </Splide>

                        :

                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={1}
                        >

                            {fotos.map((item, index) => {


                                return (
                                    <Grid container size={{xs: 12, sm: 12, md: 3}}>
                                        <Tarjeta_Img_Producto item={item}/>
                                    </Grid>
                                )


                            })}


                        </Grid>


                    }


                </Grid>


            </Grid>

        </Grid>


    )

}
export default Detalle_Coleccion_Titulo_Imgs

const items = [
    uno,
    dos,
    tres,
    uno,
    dos,
    tres,
    uno,
    dos,
    tres,
]